import ApproveConfirmation from "./ApproveConfirmation"
import SendMessage from "./SendMessage";
const Dialogs = {
    ApproveConfirmation,
    SendMessage
}
export default Dialogs;